import { defineComponent as _defineComponent } from 'vue'
import { ReservationStatus } from '@/model/Reservation';
import { PropType } from 'vue';
import { colorForStatus } from '@/components/helpers/colors';
import { reservationStatusItems } from '@/util/status';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationStatusSelect',
  props: {
  value: { type: Object as PropType<ReservationStatus>, required: true },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;



const items = reservationStatusItems();



const updateStatus = (s: ReservationStatus) => {
  emit('input', s);
};


return { __sfc: true,props, items, emit, updateStatus, colorForStatus }
}

})